import { render, staticRenderFns } from "./DepositGoalPanel.vue?vue&type=template&id=10717f67&scoped=true&"
import script from "./DepositGoalPanel.vue?vue&type=script&lang=js&"
export * from "./DepositGoalPanel.vue?vue&type=script&lang=js&"
import style0 from "./DepositGoalPanel.vue?vue&type=style&index=0&id=10717f67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10717f67",
  null
  
)

export default component.exports